import { gql } from '@apollo/client';

export const GET_CALENDAR_FEED = gql`
  query GetCalendarFeed($trainerId: ID!, $userId: ID) {
    calendarFeed(trainerId: $trainerId, userId: $userId) {
      _id
      trainerId
      userId
      url
      calendarSubscriptionIdPreview
      status
      createdAt
      updatedAt
    }
  }
`;
